import 'bootstrap/dist/css/bootstrap.min.css';
import { addLocale, FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import useParamsCIR from '../../helpers/useParamsCIR';
import useParamsCIR1009 from '../../helpers/useParamsCIR1009';
import useParamsCIR2276 from '../../helpers/useParamsCIR2276';
import dateFormat from '../../services/DateFormat.service';
import './CIR_Payroll.css';
import { Div, Form, FormGroup, H3, LabelField } from './CIR_Payroll.styles';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import Video from '../Video/Video';
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CIR_Payroll
Description : Liquidación de ingresos y retenciones de una empresa
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente de acuerdo a los cambios implemtados con PrimeReact
================================================================================ */

export default function CIR_Payroll(props) {

    /*Propiedades de los modales del componente*/
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenRC, setIsOpenRC] = React.useState(false);
    const [isOpenAcum, setIsOpenAcum] = React.useState(false);
    const [isOpen1009, setIsOpen1009] = React.useState(false);
    const [isOpen2276, setIsOpen2276] = React.useState(false);

    /*Propiedades y listas de valores del componente*/
    const [listaCir, setListaCir] = useState([])
    const [tipoCir, setTipoCir] = useState("")
    const [consultado, setConsultado] = useState(false)
    const [CIR, setCIR] = useState([])
    const [CIR1009, setCIR1009] = useState([])
    const [CIR2276, setCIR2276] = useState([])
    const [params] = useParamsCIR();
    const [params1009] = useParamsCIR1009();
    const [params2276] = useParamsCIR2276();

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [loading5, setLoading5] = useState(false);
    const [loading6, setLoading6] = useState(false);
    const [loading7, setLoading7] = useState(false);
    const [loading8, setLoading8] = useState(false);

    /*Mensajes informativos*/
    const { info } = useInfo("CIR_Payroll");

    /*Constantes varias para el componente*/
    const headers = {
        authorization: localStorage.getItem('token')
    }

    const toast = useRef(null);

    const elementWidth = { width: "20rem", justifySelf: "center" }
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [errorRows, setErrorRows] = useState([])
    const [isOpenErrors, setIsOpenErrors] = useState(false)

    /*Definición formato para el calendario del componente*/
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        /*Se cargan los datos para las listas de valores del componente*/
        const getCalendar = async () => {
            await apis.getValueListCalendar("CIR", headers).then(res => {
                let calendar = res.data.CALENDAR
                let contenidoCalendar = [];
                calendar.forEach(element =>
                    contenidoCalendar.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
                )
                setListaCir(contenidoCalendar)
            })
        }
        getCalendar()
    }, []);

    useEffect(() => {
        /*Se incializan las propiedades del componente*/
        const CIRTemplate = async () => {
            let plantilla = []
            params.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'PinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            console.log(plantilla)
            setCIR(plantilla)
        }
        CIRTemplate()
    }, [params]);

    useEffect(() => {
        /*Se incializan las propiedades del componente*/
        const CIR1009Template = async () => {
            let plantilla = []
            params1009.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            console.log(plantilla)
            setCIR1009(plantilla)
        }
        CIR1009Template()
    }, [params1009]);

    useEffect(() => {
        /*Se incializan las propiedades del componente*/
        const CIR2276Template = async () => {
            let plantilla = []
            params2276.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            console.log(plantilla)
            setCIR2276(plantilla)
        }
        CIR2276Template()
    }, [params2276]);

    /*Funciones que manejan el comportamiento de los modales del componente*/
    function handleSubmit(event) {
        event.preventDefault();
    }

    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
    };

    const showModalRC = () => {
        setIsOpenRC(true);
    };

    const hideModalRC = () => {
        setIsOpenRC(false);
    };

    const showModalAcum = () => {
        setIsOpenAcum(true);
    };

    const hideModalAcum = () => {
        setIsOpenAcum(false);
    };

    const showModal1009 = () => {
        setIsOpen1009(true);
    };

    const hideModal1009 = () => {
        setIsOpen1009(false);
    };

    const showModal2276 = () => {
        setIsOpen2276(true);
    };

    const hideModal2276 = () => {
        setIsOpen2276(false);
    };

    const showConfirm = (id, process) => {
        /*Función encargada de mostrar al usuario un mensaje de confirmación de la realización de un proceso*/
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Proceso  {process} ({id}) Realizado Existosamente</p>
                    </div>
                </div>
            )
        });
    }

    async function process(action) {
        /*Función que valida qué tipo de proceso de liquidación se desea realiza y lo ejecuta*/
        const p = {
            ID_CALENDAR: tipoCir.value,
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            ACTION: action
        }
        let msg = ""
        if (action == "PRO") {
            msg = "Procesar"
        }
        else {
            if (action == "CLO") {
                msg = "Acumular"
            }
            else {
                if (action == "REV") {
                    msg = "Deshacer"
                }
            }
        }
        try {
            await apis.executeProcess(p, headers).then(res => {
                let data = res.data.PROCESS[0]
                let id = data.ID
                setLoading1(false)
                setLoading2(false)
                setLoading3(false)
                showConfirm(id, msg)
            })
            hideModalAcum()
            setTabla()
        }
        catch (err) {
            setLoading1(false)
            setLoading2(false)
            setLoading3(false)
            toast.current.show({ severity: 'error', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postCIRReport() {
        /*Función encargada de generar la información de un reporte de ingresos y retenciones*/
        console.log(CIR)
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let p = []
        let pm = { PARAMETERS: p }
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: [pm]
        }

        CIR.forEach(c => {
            report.REPORTS[0].PARAMETERS.push({ LABEL: c.LABEL, VALUE: c.CODE })
        })
        try {
            await apis.postReportCIR(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, 'reporteIngresosRetenciones')
                setLoading4(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de ingresos y retenciones generado existosamente" });
                hideModalRC();
            })
        }
        catch (err) {
            setLoading4(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function generateFormat1009() {
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let p = []
        let pm = { PARAMETERS: p }
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: [pm]
        }

        CIR1009.forEach(c => {
            report.REPORTS[0].PARAMETERS.push({ LABEL: c.LABEL, VALUE: c.CODE })
        })
        try {
            await apis.getFormat1009(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, 'formato1009')
                setLoading7(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Formato 1009 generado existosamente" });
            })
        }
        catch (err) {
            setLoading7(false)
            toast.current.show({ severity: 'error', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function generateFormat2276() {
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let p = []
        let pm = { PARAMETERS: p }
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: [pm]
        }

        CIR2276.forEach(c => {
            report.REPORTS[0].PARAMETERS.push({ LABEL: c.LABEL, VALUE: c.CODE })
        })
        try {
            await apis.getFormat2276(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, 'formato2276')
                setLoading8(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Formato 2276 generado existosamente" });
            })
        }
        catch (err) {
            setLoading8(false)
            toast.current.show({ severity: 'error', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const percentageBodyTemplate = (rowData) => {
        return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
    }

    async function setTabla() {
        const _calendario = tipoCir.value
        try {
            await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
                if (res.data["PROCESS"].length > 0) {
                    let data = res.data["PROCESS"]
                    setRows(data)
                    setRowData(data)
                    setConsultado(true)
                    setLoading5(false)
                    setLoading6(false)
                }
                else {
                    setRows([])
                    setRowData([])
                    setLoading5(false)
                    setLoading6(false)
                }
            })
        }
        catch (err) {
            setLoading5(false)
            setLoading6(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const rowClassName = (rowData) => {
        return { 'error-row': (rowData["STATUS"] === "ERROR") };
    }

    /*Headers y footers de los modales del componente*/

    const tableHeader = (
        <div className="table-header">
            <Button icon="pi pi-refresh" loading={loading5} tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm" onClick={() => { setLoading5(true); setTabla() }} />
        </div>
    );

    const actionBodyTemplateErrors = (rowData) => {
        console.log(rowData.ERRORS)
        return (
            <div>
                {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
            </div>
        )
    }

    const footerC = (
        <>
            <div>
                <Button label="Procesar" style={{ marginLeft: "-1rem" }} loading={loading1} onClick={() => { setLoading1(true); process("PRO") }} disabled={tipoCir == false} />
                <Button label="Deshacer" loading={loading3} onClick={() => { setLoading3(true); process("REV") }} disabled={tipoCir == false} />
                <Button label="Acumular" onClick={showModalAcum} disabled={tipoCir == false} />
            </div>
            {consultado === true ?
                <div className="datatable-style-demo">
                    <DataTable className="text-xs" header={tableHeader} value={rows} first={first2} rows={rows2} onPage={onCustomPage2}
                        selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['ID', 'TRHEAD', 'JOB', 'RECORD', 'START', 'END', 'PROCESSED', 'ERROR', 'PERCENTAGE', 'ACTION', 'STATUS']}
                        rowClassName={rowClassName}
                    >
                        <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplateErrors}></Column>
                        <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                        <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
                        <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
                        <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
                        <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
                        <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
                        <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
                        <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
                        <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
                    </DataTable>
                </div>
                : null}
        </>
    );

    const headerC = (
        <div>
            <h3>Seleccionar calendario para liquidación de ingresos y retenciones</h3>
        </div>
    )

    const footerRC = (
        <div>
            <Button label="Generar" loading={loading4} onClick={() => { setLoading4(true); postCIRReport() }} />
        </div>
    );

    const headerRC = (
        <div>
            <h3>Parámetros reporte ingresos y retenciones</h3>
        </div>
    )

    const headerAcum = (
        <div>
            <h3>¿Desea realizar la acumulación del proceso?</h3>
        </div>
    )

    const footerAcum = (
        <div>
            <Button label="Si" loading={loading2} onClick={() => { setLoading2(true); process("CLO") }} />
            <Button label="No" onClick={hideModalAcum} />
        </div>
    );

    const footer1009 = (
        <div>
            <Button label="Generar" loading={loading7} onClick={() => { setLoading7(true); generateFormat1009() }} />
        </div>
    );

    const header1009 = (
        <div>
            <h3>Parámetros reporte Formato 1009</h3>
        </div>
    )

    const footer2276 = (
        <div>
            <Button label="Generar" loading={loading8} onClick={() => { setLoading8(true); generateFormat2276() }} />
        </div>
    );

    const header2276 = (
        <div>
            <h3>Parámetros reporte Formato 2276</h3>
        </div>
    )

    /*Funciones que manejan los eventos que cambian los campos de entrada del componente*/
    function handleChange(e, d, index) {
        //console.log(e.value)
        setCIR(c => {
            let newCIR = [...c]
            console.log(index)
            console.log(c)
            newCIR[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })

        //console.log(nomina[index]["NAME"])
    }

    async function handleChangeDate(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setCIR(c => {
            let newCIR = [...c]
            newCIR[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })
        //console.log(nomina)
    }

    async function handleChangeText(e, d, index) {
        //console.log(e.value)
        setCIR(c => {
            let newCIR = [...c]
            newCIR[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })
        //console.log(nomina)
    }

    function handleChange1009(e, d, index) {
        //console.log(e.value)
        setCIR1009(c => {
            let newCIR = [...c]
            console.log(index)
            console.log(c)
            newCIR[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })

        //console.log(nomina[index]["NAME"])
    }

    async function handleChangeDate1009(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setCIR1009(c => {
            let newCIR = [...c]
            newCIR[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })
        //console.log(nomina)
    }

    async function handleChangeText1009(e, d, index) {
        //console.log(e.value)
        setCIR1009(c => {
            let newCIR = [...c]
            newCIR[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })
        //console.log(nomina)
    }

    function handleChange2276(e, d, index) {
        //console.log(e.value)
        setCIR2276(c => {
            let newCIR = [...c]
            console.log(index)
            console.log(c)
            newCIR[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })

        //console.log(nomina[index]["NAME"])
    }

    async function handleChangeDate2276(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setCIR2276(c => {
            let newCIR = [...c]
            newCIR[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })
        //console.log(nomina)
    }

    async function handleChangeText2276(e, d, index) {
        //console.log(e.value)
        setCIR2276(c => {
            let newCIR = [...c]
            newCIR[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newCIR
        })
        //console.log(nomina)
    }
    /*Renderizado del componente*/
    return (
        <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Dialog header={headerC} footer={footerC} visible={isOpen} style={{ width: '27rem' }}
                maximizable position="top" draggable={false} resizable={false} modal onHide={hideModal}>
                <Tooltip target=".info" className='indigo-tooltip ml-1' />
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                <LabelField htmlFor="label">Calendario liquidación de CIR *</LabelField>
                <InfoIcon msg={info[0]}
                    element={
                        <div className="p-inputgroup">
                            <Tooltip target=".info" className='indigo-tooltip ml-1' />
                            <Dropdown style={elementWidth} value={tipoCir.value} emptyMessage={"No hay calendarios disponibles"}
                                options={listaCir} placeholder={"Seleccione el calendario"}
                                onChange={(e) => {
                                    let label = e.originalEvent.nativeEvent.target.textContent;
                                    setTipoCir({ "value": e.value, "label": label })
                                    console.log(e)
                                    console.log(tipoCir)
                                }}
                                filter showClear={true} filterBy="label"
                            />
                            <Button icon="pi pi-search" loading={loading6} className="mr-0 p-button-sm text-xs" tooltip="Consultar procesos anteriores"
                                tooltipOptions={{ position: 'top' }} onClick={() => { setLoading6(true); setTabla() }} disabled={tipoCir == false} />
                        </div>
                    }
                />
            </Dialog>
            <Dialog header={headerAcum} footer={footerAcum} visible={isOpenAcum} position="top"
                style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalAcum} />
            <Dialog header={headerRC} footer={footerRC} visible={isOpenRC} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalRC}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                {params.map((d, index) => {
                    /*Generación dinámica de los campos de entrada del modal del componente*/
                    if (d.TAG !== "PinClient" && d.TAG !== "pinEntity" && CIR.length > 0 && typeof CIR[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={CIR[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={CIR[index]["NAME"] ? CIR[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChange(e, d, index)}
                                    />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Calendar key={d} style={elementWidth} id="navigators" value={CIR[index].CODE}
                                        onChange={(e) => handleChangeDate(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={CIR[index].CODE}
                                        yearRange="2010:2030" /></>
                                );
                            default:
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={CIR[index]}
                                        onChange={(e) => handleChangeText(e, d, index)}
                                    /></>
                                )
                        }
                    }
                })}
            </Dialog>
            <Dialog header={header1009} footer={footer1009} visible={isOpen1009} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal1009}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                {params1009.map((d, index) => {
                    /*Generación dinámica de los campos de entrada del modal del componente*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && CIR.length > 0 && typeof CIR1009[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={CIR1009[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={CIR1009[index]["NAME"] ? CIR1009[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChange1009(e, d, index)}
                                    />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Calendar key={d} style={elementWidth} id="navigators" value={CIR1009[index].CODE}
                                        onChange={(e) => handleChangeDate1009(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={CIR1009[index].CODE}
                                        yearRange="2010:2030" /></>
                                );
                            default:
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={CIR1009[index]["NAME"]}
                                        onChange={(e) => handleChangeText1009(e, d, index)}
                                    /></>
                                )
                        }
                    }
                })}
            </Dialog>
            <Dialog header={header2276} footer={footer2276} visible={isOpen2276} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal2276}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                {params2276.map((d, index) => {
                    /*Generación dinámica de los campos de entrada del modal del componente*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && CIR.length > 0 && typeof CIR2276[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={CIR2276[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={CIR2276[index]["NAME"] ? CIR2276[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChange2276(e, d, index)}
                                    />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Calendar key={d} style={elementWidth} id="navigators" value={CIR2276[index].CODE}
                                        onChange={(e) => handleChangeDate2276(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={CIR2276[index].CODE}
                                        yearRange="2010:2030" /></>
                                );
                            default:
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={CIR2276[index]["NAME"]}
                                        onChange={(e) => handleChangeText2276(e, d, index)}
                                    /></>
                                )
                        }
                    }
                })}
            </Dialog>

            <Dialog header={"Errores"} visible={isOpenErrors}
                position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
                <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

                    <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
                        <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
                        <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
                    </DataTable>
                </div>
            </Dialog>

            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
                <span className="text-900">Liquidación</span>
                <Video header="Instructivo liquidación ingresos y retenciones" url={localStorage.getItem('CIR_PAYROLL_VIDEO')} />
            </div>
            <Form onSubmit={handleSubmit}>
                <Card className='shadow-5'>
                    <H3>Certificado de Ingresos y Retenciones</H3>
                    <Div>
                        <FormGroup>
                            <Button block type="submit" label='Liquidar' onClick={showModal} />
                        </FormGroup>
                    </Div>

                    <H3>Consulta</H3>
                    <Div>
                        <FormGroup>
                            <Button block type="submit" label='Reporte detallado' onClick={showModalRC} />
                        </FormGroup>
                    </Div>

                    <H3>Medios magnéticos</H3>
                    <Div>
                        <FormGroup>
                            <Button block type="submit" label='Formato 1009' onClick={showModal1009} />
                        </FormGroup>
                    </Div>
                    <Div>
                        <FormGroup>
                            <Button block type="submit" label='Formato 2276' onClick={showModal2276} />
                        </FormGroup>
                    </Div>
                </Card>
            </Form>
        </div>
    );
}